// Ported from Magic UI "marquee" (https://magicui.design/docs/components/marquee), Tailwind 3 syntax.
import React from 'react';
import { cn } from '../../lib/utils';

export function Marquee({ className, reverse = false, pauseOnHover = false, children, repeat = 4, ...props }) {
  return (
    <div
      {...props}
      className={cn('group flex flex-row gap-[var(--gap)] overflow-hidden p-2 [--duration:40s] [--gap:1rem]', className)}
    >
      {Array(repeat)
        .fill(0)
        .map((_, i) => (
          <div
            key={i}
            aria-hidden={i > 0 ? 'true' : undefined}
            className={cn('flex shrink-0 animate-marquee flex-row justify-around gap-[var(--gap)]', {
              'group-hover:[animation-play-state:paused]': pauseOnHover,
              '[animation-direction:reverse]': reverse,
            })}
          >
            {children}
          </div>
        ))}
    </div>
  );
}
